import { Dictionary } from '../../../../types/globals';
import { DataFetchingState } from '../dataFetching/generators';

export interface CategoryResponse {
    success: boolean;
    errors: [];
    data: CategoryDataResponseFromApi[];
}

export interface CategoryDataResponseFromApi {
    /* eslint-disable @typescript-eslint/camelcase, camelcase */
    name: string;
    id_catalog_category: string;
    url_key: string;
    children?: CategoryDataResponseFromApi[];
    category_color?: string;
    category_shortname?: string;
    category_all_products_text?: string | null;
    category_nav_hidden?: boolean;
    flyoutData?: {
        header_filyout_image: string;
        header_filyout_title: string;
        header_filyout_cta_text: string;
        header_filyout_cta_link: string;
        header_filyout_tracking: string;
        header_filyout_image_alt: string;
    };
    /* eslint-enable @typescript-eslint/camelcase, camelcase */
}

export interface CategoryData {
    name: string;
    shortName?: string;
    allProductsText?: string | null;
    url: string;
    urlKey?: string;
    isStaticCategory?: boolean;
    children?: CategoryData[];
    depthLevel: number;
    flyoutData?: CategoryTeaserData;
    hexColor?: string;
    isHidden?: boolean;
}

export interface CategoryTeaserData {
    image: string;
    title: string;
    ctaText: string;
    ctaLink: string;
    imageAlt: string;
    trackingId: string;
}

export interface CategoryEntity {
    id: string;
    name: string;
    urlKey: string;
    children?: string[];
    parent: string | null;
    depthLevel: number;
    isHidden?: boolean;
}

export interface SeoCategoryBreadCrumbItem {
    name: string;
    url: string;
    parent: SeoCategoryBreadCrumbItem | null;
    depthLevel: number;
}

export interface NormalizedEntitiesAndUrlKeys {
    entities: Dictionary<CategoryEntity>;
    urlKeys: Dictionary<string>;
}

export interface NormalizedCategoriesData extends NormalizedEntitiesAndUrlKeys {
    categories: string[];
}

export enum CategoryActionsTypes {
    RESPONSE = 'RESPONSE',
}
export interface CategoryAction {
    type: CategoryActionsTypes;
    response: CategoryResponse;
}

export interface CategoriesState extends DataFetchingState {
    isFetching: boolean;
    didInvalidate: boolean;
    originalCategories: CategoryData[];
    visibleOriginalCategories: CategoryData[];
    normalized: NormalizedCategoriesData | null;
}
